import { PayloadAction } from "@reduxjs/toolkit";
import { put, call, all } from "redux-saga/effects";

import { Roles } from "config";
import { IKeyData } from "infrastructure";
import { notification } from "infrastructure/notification";
import { takeLatest } from "infrastructure/store/sagaEffects";
import { securityMessages } from "ui/screens/security/security.localization";
import { filterPickerData } from "ui/screens/security/shared/picker";

import { tenantActions } from "./Tenant.actions";
import { getTenants, getEnterpriseTenants } from "./Tenant.api";
import { ITenantsResponse } from "./Tenant.api.types";
import { ITenant, ITenantSearchCriterion } from "./Tenant.state";

function* loadTenantsExecute({ payload }: PayloadAction<IKeyData<ITenantSearchCriterion>>) {
  try {
    let tenantsResponse: ITenantsResponse[] = [];

    if (payload.data.enterpriseId) {
      tenantsResponse = yield call(getEnterpriseTenants, {
        securityRoles: [Roles.PlexSecurityAdmin, Roles.SecurityAdmin],
        enterpriseId: payload.data.enterpriseId
      });
    } else {
      tenantsResponse = yield call(getTenants, { securityRoles: [Roles.PlexSecurityAdmin, Roles.SecurityAdmin] });
    }

    const tenants: ITenant[] = filterPickerData(
      tenantsResponse.map<ITenant>(e => {
        return {
          tenantId: e.tenantId,
          tenantName: e.name
        };
      }),
      { ...payload.data, defaultValueProvider: e => e.tenantName }
    );

    yield put(
      tenantActions.loadTenantsCompleted({
        id: payload.id,
        data: tenants
      })
    );
  } catch (e) {
    yield put(
      tenantActions.loadTenantsFailed({
        id: payload.id,
        data: notification.error(e).useMessageId(securityMessages.error("loadTenantsFailed"))
      })
    );
  }
}

export function* tenantsSaga() {
  yield all([yield takeLatest(tenantActions.loadTenants.toString(), loadTenantsExecute)]);
}
